var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenPoAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71758 2.89589L1.36508 13.5009C1.2341 13.7277 1.1648 13.9849 1.16407 14.2468C1.16334 14.5087 1.23119 14.7662 1.3609 14.9938C1.4906 15.2213 1.67762 15.4109 1.90336 15.5438C2.12909 15.6766 2.38568 15.748 2.64758 15.7509H15.3526C15.6145 15.748 15.8711 15.6766 16.0968 15.5438C16.3225 15.4109 16.5096 15.2213 16.6393 14.9938C16.769 14.7662 16.8368 14.5087 16.8361 14.2468C16.8354 13.9849 16.7661 13.7277 16.6351 13.5009L10.2826 2.89589C10.1489 2.67547 9.96062 2.49323 9.73597 2.36675C9.51133 2.24027 9.25788 2.17383 9.00008 2.17383C8.74228 2.17383 8.48882 2.24027 8.26418 2.36675C8.03954 2.49323 7.85128 2.67547 7.71758 2.89589Z",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.75V9.75",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.75H9.0075",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenPoAlert);
export default __webpack_public_path__ + "static/media/Open PO Alert.a056ac37be9048cbb9d1f141cdb090f7.svg";
export { ForwardRef as ReactComponent };